import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vd-page-container d-flex justify-center",class:_vm.spacingClass},[_c(VSheet,{attrs:{"width":_vm.containerSize,"color":_vm.color}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }